import { hstack } from '@flipster/styled-system/patterns';

export const authButtonCSSRaw = hstack.raw({
  pos: 'relative',
  textStyle: 'Text/L/Strong',
  justify: 'center',
  h: 50,
  w: '100%',
  gap: 8,
  rounded: 4,
  bgColor: 'background.default.level-1',
  color: 'content.default.level-5',
  overflow: 'hidden',
  _disabled: {
    bgColor: 'background.interaction.disabled',
  },
});
